var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNanoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baf85c92-41ee-467b-a286-f575f1f52b1c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a52751e3-7476-40ad-9c6a-f0f3c62b0d6a {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .ac96b380-a20e-4020-8bf7-658004d64d95 {\r\n        fill: #aa0707;\r\n      }\r\n\r\n      .f0ba74e2-dde4-4983-bf01-6e2bd7c1e42f {\r\n        fill: red;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "a52751e3-7476-40ad-9c6a-f0f3c62b0d6a",
    points: "95.037 10.242 32.963 10.242 1.926 64 32.963 117.758 64 92.979 95.037 117.758 126.074 64 95.037 10.242"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ac96b380-a20e-4020-8bf7-658004d64d95",
    x: 28.061,
    y: 43.744,
    width: 71.878,
    height: 20.256
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f0ba74e2-dde4-4983-bf01-6e2bd7c1e42f",
    x: 45.896,
    y: 43.744,
    width: 27.535,
    height: 20.256
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNanoLogo);
export default __webpack_public_path__ + "static/media/NanoLogo.b6bddfe812126d5ca5f566a01f72c1ce.svg";
export { ForwardRef as ReactComponent };